import { render, staticRenderFns } from "./InsertFile.vue?vue&type=template&id=f9db2bda"
import script from "./InsertFile.vue?vue&type=script&lang=js"
export * from "./InsertFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports